<template>
  <Modal v-model="messageTemplateModal" class-name="messageTemplateStyle" :title="messageTemplateTitle" :width="modalWidth"
    :transfer="false" :mask-closable="false" @on-visible-change="messageTemplateModalChange">
    <Form ref="messageTemplateForm" :model="messageTemplateForm" :rules="ruleValidate" :label-width="setLabelWidth" @submit.native.prevent>
      <Row type="flex" style="width: 95%;">
        <Col v-bind="formColBind">
          <Form-item :label="$t('key1002280')" prop="name">
            <Input clearable v-model.trim="messageTemplateForm.name" :maxlength="20"
              :placeholder="$t('key1002281')"></Input>
          </Form-item>
        </Col>
        <Col v-bind="formColBind">
          <Form-item :label="$t('key1002282')" prop="informationType">
            <Select v-model="messageTemplateForm.informationType" filterable transfer>
              <Option v-for="(item, index) in informationTypeList" :value="item.value" :key="index">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col v-bind="formColBind">
          <Form-item :label="$t('key1002283')">
            <span v-if="isInstantTriggerType" class="font-size-12">{{ triggerConditionText }}</span>
            <div v-else class="flex align-items-center">
              <span class="font-size-12">{{ triggerConditionText }}{{ $t('key1002292') }}</span>
              <InputNumber :max="triggerMaxTime" :min="triggerMinTime" v-model="messageTemplateForm.triggerValue" style="margin: 0 6px"></InputNumber>
              <Select v-model="messageTemplateForm.triggerType" style="width:100px" @on-change="changeTriggerTime">
                <Option v-for="item in triggerTypeList" :value="item.value" :key="item.value">{{ item.name }}</Option>
              </Select>
            </div>
          </Form-item>
        </Col>
        <Col v-bind="formColBind">
          <Form-item :label="$t('key1002284')">
            <span class="font-size-12 channel-text">{{ notificationChannel }}</span>
          </Form-item>
        </Col>
        <Col v-bind="formColBind">
          <Form-item :label="$t('key1002285')" prop="receiveModeList">
            <CheckboxGroup class="flex align-items-center" v-model="messageTemplateForm.receiveModeList" @on-change="receiveModeChange">
              <Checkbox label="1" disabled>{{ $t('key1002266') }}</Checkbox>
              <!--              <Checkbox label="3>2">
                              <span>短信->邮箱</span>
                              <Tooltip max-width="300" content="短信优先提醒，如果没有手机号，再通过邮件提醒">
                                <Icon class="help_icon" type="md-help-circle"></Icon>
                              </Tooltip>
                            </Checkbox>
                            <Checkbox label="2>3">
                              <span>邮箱->短信</span>
                              <Tooltip max-width="300" content="邮箱优先提醒，如果没有邮箱，再通过短信提醒">
                                <Icon class="help_icon" type="md-help-circle"></Icon>
                              </Tooltip>
                            </Checkbox>-->
            </CheckboxGroup>
          </Form-item>
        </Col>
        <Col v-bind="formColBind">
          <Form-item :label="$t('key1002286')" prop="isPopup">
            <RadioGroup v-model="messageTemplateForm.isPopup">
              <Radio class="mr30" :label="1">{{ $t('key1000392') }}</Radio>
              <Radio :label="0">{{ $t('key1000393') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <Col v-bind="formColBind">
          <Form-item :label="$t('key1002287')">
            <RadioGroup class="reminder_box" v-model="messageTemplateForm.remindMode">
              <Radio class="mr30" :label="1">{{ $t('key1002293') }}</Radio>
              <Radio :label="2" :disabled="isFixedRemindDisabled">
                <span>{{ $t('key1002294') }}</span>
                <Tooltip transfer max-width="400" placement="top" :content="$t('key1002288')">
                  <Icon class="help_icon" type="md-help-circle"></Icon>
                </Tooltip>
              </Radio>
            </RadioGroup>
            <div class="flex align-items-center mt10" v-if="messageTemplateForm.remindMode === 2">
              <span>{{ $t('key1002295') }}</span>
              <InputNumber :max="reminderMaxTime" :min="reminderMinTime" v-model="messageTemplateForm.remindValue"
                style="margin: 0 8px; width:80px;"></InputNumber>
              <Select v-model="messageTemplateForm.remindType" style="width:80px" @on-change="changeReminderTime">
                <Option v-for="item in remindTypeList" :value="item.value" :key="item.value">{{ item.name }}</Option>
              </Select>
              <Select
                class="select_timer"
                v-if="messageTemplateForm.remindType === 'd'"
                v-model="messageTemplateForm.remindTime"
                :placeholder="$t('key1002289')"
                clearable
                style="width: 120px; margin-left: 8px;">
                <Option v-for="(item, index) in timerList" :key="index" :value="item.value">{{ item.value }}</Option>
              </Select>
              <span style="margin-left: 8px;">{{ $t('key1002296') }}</span>
            </div>
          </Form-item>
        </Col>
        <div class="flex align-items-start wp100">
          <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
            <template v-for="item in multilingualNamesList">
              <template :slot="item.name">
                <Col v-bind="formColBind">
                  <Form-item :label="labelNameRender(item)">
                    <Input v-model="messageTemplateForm['title_' + item.code]" :ref="'inputTitle_' + item.code"
                      type="textarea" :autosize="{ minRows: 5, maxRows: 5 }" v-show="editTitleTalg" @on-blur="blurMultilingualEdit('title')"/>
                    <div :ref="'msgName_' + item.code" v-html="messageContent['title_'+ item.code]"
                      class="message_content_style" v-show="!editTitleTalg" @click="toggleMultilingualEdit('title')"></div>
                  </Form-item>
                </Col>
                <Col v-bind="formColBind">
                  <Form-item :label="labelContentRender(item)">
                    <Input v-model="messageTemplateForm['content_' + item.code]" :ref="'inputContent_' + item.code"
                      type="textarea" :autosize="{ minRows: 5, maxRows: 5 }" v-show="editContentTalg" @on-blur="blurMultilingualEdit('content')"/>
                    <div :ref="'msgContent_' + item.code" v-html="messageContent['content_' + item.code]"
                      class="message_content_style" v-show="!editContentTalg" @click="toggleMultilingualEdit('content')"></div>
                    <!--因为涉及多语种发送短信问题，暂时先屏蔽掉字数限制，通知方式也只先开放站内信
                                      <div class="number_style">
                                        <span>{{ availableNumber }}</span>
                                        <span>/</span>
                                        <span>{{ maxNumber }}</span>
                                      </div>-->
                    <div class="content-tip">{{ $t('key1002297') }}</div>
                    <div class="content-tip">{{ $t('key1002298') }}</div>
                    <div class="content-tip content-tip-last">{{ $t('key1002299') }}</div>
                  </Form-item>
                </Col>
              </template>
            </template>
          </languagesTabs>
          <!--动态参数-->
          <div class="dynamicParam_box" :style="setDynamicParamStyle" v-if="dynamicParamList.length >0">
            <h3 class="title">{{ $t('key1002300') }}</h3>
            <div class="dynamicParam_box_item" v-for="(item, index) in dynamicParamList" :key="index">
              <draggable v-model="dynamicParamList" @end="handleDragEnd" @start="handleDragStart" :sort="false" :forceFallback="true" :dragClass="'dragClass'">
                <p class="cursor-move themeColor" style="font-size: 14px;">{{ $t('key1002290') + item.placeholder }}</p>
              </draggable>
              <p>{{ $t('key1002291') + item.name }}</p>
            </div>
          </div>
        </div>
        <Col v-bind="formColBind">
          <Form-item :label="$t('key1001522')" prop="status">
            <RadioGroup v-model="messageTemplateForm.status">
              <Radio class="mr30" :label="1">{{ $t('key1000462') }}</Radio>
              <Radio :label="2">{{ $t('key1000463') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="messageTemplateModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="messageTemplateBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import languagesTabs from '@/components/common/languagesTabs.vue';
import {INFORMATIONTYPELIST} from '@/utils/enum';
import draggable from 'vuedraggable';
import {getDataSetBatchList, getEnumList, isChineseLanguage} from '@/utils/common';

// 需配置「状态停留时间」的消息类型（运营侧超时类：备货/拣货/换单/装箱/发货）
const TIME_BASED_TRIGGER_TYPES = [2, 3, 4, 5, 6];
// 仅支持及时提醒、不可选固定时间的消息类型（缺货、订单取消）
const FIXED_REMIND_DISABLED_TYPES = [1, 7];
// 新增模板时默认开启弹窗提醒的消息类型
const POPUP_DEFAULT_ON_TYPES = [12, 13, 14, 15, 16, 17, 18, 19];
// 标题使用 item.title 而非 item.name 的消息类型
const CUSTOM_TITLE_TYPES = [9, 10, 16];
// 固定提醒模式下可选的具体小时点（6:00-23:00，不含 11:00）
const REMINDER_HOUR_OPTIONS = [6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

// 触发条件停留时间的 InputNumber 范围（h=小时，d=天）
const TRIGGER_TIME_RANGE = {
  h: {max: 24, min: 0, defaultValue: 0},
  d: {max: 5, min: 1, defaultValue: 1}
};
// 固定提醒频率的 InputNumber 范围（h=小时，d=天）
const REMINDER_TIME_RANGE = {
  h: {max: 12, min: 1, defaultValue: 1},
  d: {max: 5, min: 1, defaultValue: 1}
};

// 表单默认值，用于新增初始化与关闭弹窗重置
const DEFAULT_FORM = {
  name: '',
  informationType: null,
  triggerValue: 0, // 触发频率
  triggerType: 'h', // 触发单位：h 小时 / d 天
  receiveModeList: ['1'], // 1 站内信 2 邮箱 3 短信
  isPopup: 0, // 是否弹窗：1 是 / 0 否
  remindMode: 1, // 提醒模式：1 及时 / 2 固定时间
  remindValue: 1, // 固定提醒频率
  remindTime: null, // 固定提醒具体时刻（remindType 为 d 时）
  remindType: 'd', // 提醒单位：h 小时 / d 天
  status: 1, // 模板状态：1 启用 / 2 停用
  notificationType: 2
};

export default {
  name: 'messageTemplateModal',
  components: {languagesTabs, draggable},
  mixins: [Mixin],
  props: {
    // 通知到供应商系统的消息类型 value 列表
    supplierNoticeType: {
      type: Array,
      default: () => []
    },
    // 通知到分销商系统的消息类型 value 列表
    distributorNoticeType: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      messageTemplateModal: false,
      messageTemplateTalg: 'add', // add 新增 / edit 编辑
      messageTemplateTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002270'),
      messageTemplateForm: {...DEFAULT_FORM},
      ruleValidate: {
        informationType: [
          {type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002273'), trigger: 'change'}
        ],
      },
      triggerConditionText: '', // 触发条件展示文案
      notificationChannel: '', // 通知渠道：运营/供应商/分销商系统
      triggerMaxTime: TRIGGER_TIME_RANGE.h.max,
      triggerMinTime: TRIGGER_TIME_RANGE.h.min,
      reminderMaxTime: REMINDER_TIME_RANGE.h.max,
      reminderMinTime: REMINDER_TIME_RANGE.h.min,
      messageContent: {}, // 多语言标题/内容预览区 HTML（含动态参数高亮）
      availableNumber: 0, // 短信字数统计（功能暂屏蔽）
      maxNumber: 67, // 短信字数上限（功能暂屏蔽）
      informationTypeList: INFORMATIONTYPELIST,
      editContentTalg: false, // 是否处于内容编辑态
      editTitleTalg: false, // 是否处于标题编辑态
      dynamicParamList: [], // 当前消息类型可拖拽的动态参数字段
      enumData: [] // 触发/提醒单位枚举数据源
    };
  },
  computed: {
    // 触发条件时间单位下拉（小时/天）
    triggerTypeList() {
      return getEnumList(this.enumData, 'YmsStationNotificationTemplateTriggerTypeCoreEnum');
    },
    // 固定提醒时间单位下拉（小时/天）
    remindTypeList() {
      return getEnumList(this.enumData, 'YmsStationNotificationTemplateRemindTypeCoreEnum');
    },
    setLabelWidth() {
      return isChineseLanguage() ? 90 : 150;
    },
    modalWidth() {
      return isChineseLanguage() ? 700 : 1000;
    },
    setDynamicParamStyle() {
      return isChineseLanguage() ? {width: '110px'} : {width: '220px'};
    },
    // 表单项 Col 栅格绑定，避免模板重复书写
    formColBind() {
      return {
        xxl: this.oneItemCol,
        xl: this.oneItemCol,
        lg: this.oneItemCol,
        md: this.oneItemCol
      };
    },
    // 是否为即时触发（仅展示文案，无需配置停留时间）
    isInstantTriggerType() {
      return !TIME_BASED_TRIGGER_TYPES.includes(this.messageTemplateForm.informationType);
    },
    // 当前消息类型是否禁用「固定时间」提醒
    isFixedRemindDisabled() {
      return FIXED_REMIND_DISABLED_TYPES.includes(this.messageTemplateForm.informationType);
    },
    // 固定提醒模式下「天」单位可选的具体时刻
    timerList() {
      return REMINDER_HOUR_OPTIONS.map((hour) => ({
        value: `${String(hour).padStart(2, '0')}:00`
      }));
    }
  },
  methods: {
    // 多语言 Tab 标题表单项 label
    labelNameRender(params) {
      return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000093') + params.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000000');
    },
    // 多语言 Tab 内容表单项 label
    labelContentRender(params) {
      return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000093') + params.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002274');
    },
    // 初始化弹窗数据
    async initMessageTemplateData(type, ymsStationNotificationTemplateId) {
      const enumKeyList = [
        'YmsStationNotificationTemplateTriggerTypeCoreEnum',
        'YmsStationNotificationTemplateRemindTypeCoreEnum'
      ];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.$refs['languagesTab'].tabName = this.languagesVal;
      this.initMultilingualFields('messageContent', this.messageContent, ['title_', 'content_']);
      this.initMultilingualFields('messageTemplateForm', this.messageTemplateForm, ['title_', 'content_']).then(() => {
        const titleObj = {
          add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002270'),
          edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002275')
        };
        this.messageTemplateTalg = type;
        this.messageTemplateTitle = titleObj[type];
        if (type === 'edit') {
          this.loadMessageTemplate(ymsStationNotificationTemplateId);
        } else {
          this.messageTemplateModal = true;
        }
      });
    },
    // 加载编辑数据
    loadMessageTemplate(ymsStationNotificationTemplateId) {
      this.axios.get(api.get_ymsStationNotificationTemplate + ymsStationNotificationTemplateId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          const data = response.data.datas;
          const {title, content, ...vals} = data;
          this.messageTemplateForm = vals;
          this.messageTemplateForm.name = data.name;
          if (data.remindTime) {
            const time = data.remindTime.split(':');
            this.messageTemplateForm.remindTime = time[0] + ':' + time[1];
          } else {
            this.messageTemplateForm.remindTime = null;
          }
          this.setTimeRangeConfig(this.messageTemplateForm.triggerType, 'trigger', false);
          this.setTimeRangeConfig(this.messageTemplateForm.remindType, 'reminder', false);

          const obj = this.handleMultilingualFormFields(data, ['title', 'content']);
          this.multilingualNamesList.forEach((item) => {
            this.messageContent['title_' + item.code] = this.handerText(obj['title_' + item.code]) || '';
            this.messageContent['content_' + item.code] = this.handerText(obj['content_' + item.code]) || '';
            this.$nextTick(() => {
              this.messageTemplateForm['title_' + item.code] = obj['title_' + item.code] || '';
              this.messageTemplateForm['content_' + item.code] = obj['content_' + item.code] || '';
            });
          });
          this.messageTemplateModal = true;
        }
      });
    },
    // 提交前校验表单
    validateBeforeSubmit() {
      const form = this.messageTemplateForm;
      if (form.remindType === 'd' && form.remindMode === 2 && !form.remindTime) {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002276');
      }
      if (TIME_BASED_TRIGGER_TYPES.includes(form.informationType)) {
        if (!form.triggerValue && form.triggerValue !== 0) {
          return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002277');
        }
      }
      if (form.remindMode === 2 && !form.remindValue) {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002278');
      }
      const zhItem = this.multilingualNamesList.find((ele) => ele.code === 'zh-CN');
      if (zhItem) {
        if (!form['title_' + zhItem.code]) {
          return `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000093')}${zhItem.title}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002271')}`;
        }
        if (!form['content_' + zhItem.code]) {
          return `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000093')}${zhItem.title}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002272')}`;
        }
      }
      return '';
    },
    // 消息模板弹窗确定
    messageTemplateBtn() {
      const validateMsg = this.validateBeforeSubmit();
      if (validateMsg) {
        this.$Message.warning(validateMsg);
        return;
      }
      const isAdd = this.messageTemplateTalg === 'add';
      const url = isAdd ? api.post_ymsStationNotificationTemplate : api.put_ymsStationNotificationTemplate;
      const method = isAdd ? 'post' : 'put';
      const text = isAdd ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
      const params = this.handleMultilingualMultipleParam(this.messageTemplateForm, ['title_', 'content_']);
      this.$refs['messageTemplateForm'].validate((valid) => {
        if (valid) {
          this.axios[method](url, params, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              this.messageTemplateModal = false;
              this.$Message.success(text);
              this.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 按单位设置触发/提醒时间的范围与默认值
    setTimeRangeConfig(unit, target, updateValue = true) {
      const rangeMap = target === 'trigger' ? TRIGGER_TIME_RANGE : REMINDER_TIME_RANGE;
      const config = rangeMap[unit] || rangeMap.h;
      if (target === 'trigger') {
        this.triggerMaxTime = config.max;
        this.triggerMinTime = config.min;
        if (updateValue) {
          this.messageTemplateForm.triggerValue = config.defaultValue;
        }
      } else {
        this.reminderMaxTime = config.max;
        this.reminderMinTime = config.min;
        if (updateValue) {
          this.messageTemplateForm.remindValue = config.defaultValue;
        }
      }
    },
    // 切换触发条件时间单位
    changeTriggerTime(value) {
      this.setTimeRangeConfig(value, 'trigger');
    },
    // 切换固定提醒时间单位
    changeReminderTime(value) {
      this.setTimeRangeConfig(value, 'reminder');
    },
    // 切回及时提醒时重置固定时间字段
    resetRemindFields() {
      this.messageTemplateForm.remindValue = 1;
      this.messageTemplateForm.remindTime = null;
      this.messageTemplateForm.remindType = 'd';
    },
    // 关闭弹窗时恢复初始状态
    resetFormState() {
      this.$refs['messageTemplateForm'].resetFields();
      Object.assign(this.messageTemplateForm, {...DEFAULT_FORM});
      this.triggerConditionText = '';
      this.notificationChannel = '';
      this.messageTemplateTitle = '';
      this.triggerMaxTime = TRIGGER_TIME_RANGE.h.max;
      this.triggerMinTime = TRIGGER_TIME_RANGE.h.min;
      this.reminderMaxTime = REMINDER_TIME_RANGE.h.max;
      this.reminderMinTime = REMINDER_TIME_RANGE.h.min;
      this.messageContent = {};
      this.availableNumber = 0;
      this.dynamicParamList = [];
      this.editTitleTalg = false;
      this.editContentTalg = false;
    },
    // 通知方式多选变更（恢复短信/邮箱组合选项时限制最多选两项）
    receiveModeChange(list) {
      if (list) {
        let newArr = [list[0], list[list.length - 1]];
        newArr = this.uniqueFunc(newArr);
        this.messageTemplateForm.receiveModeList = newArr;
      }
    },
    // 弹窗显隐变化，关闭时重置表单
    messageTemplateModalChange(value) {
      if (!value) {
        this.resetFormState();
      }
    },
    // 切换消息类型后同步模板与渠道信息
    applyInformationType(item, value, oldValue) {
      const tabName = this.$refs['languagesTab'] && this.$refs['languagesTab'].tabName;
      if (!item || !tabName) {
        return;
      }
      this.dynamicParamList = item.dynamicParamList || [];
      const shouldSyncTemplate = this.messageTemplateTalg === 'add' ||
        (this.messageTemplateTalg === 'edit' && oldValue != null && oldValue !== value);

      if (shouldSyncTemplate) {
        const titleContent = CUSTOM_TITLE_TYPES.includes(value) ? item.title : item.name;
        this.messageContent['content_' + tabName] = item.messageTemplate;
        this.messageContent['title_' + tabName] = titleContent;
        if (this.messageTemplateTalg === 'add') {
          this.messageTemplateForm.name = item.name;
          this.messageTemplateForm.isPopup = POPUP_DEFAULT_ON_TYPES.includes(value) ? 1 : 0;
        }
        this.syncMultilingualFormFromView(tabName);
      }

      if (this.distributorNoticeType.includes(value)) {
        this.triggerConditionText = item.triggerConditionTxt;
        this.notificationChannel = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000015');
        if (this.messageTemplateTalg === 'add') {
          this.messageTemplateForm.remindMode = 1;
        }
      } else if (this.supplierNoticeType.includes(value)) {
        this.triggerConditionText = item.triggerConditionTxt;
        this.notificationChannel = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000014');
        if (this.messageTemplateTalg === 'add') {
          this.messageTemplateForm.remindMode = 1;
        }
      } else {
        this.triggerConditionText = item.text;
        this.notificationChannel = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000013');
      }
    },
    // 从预览区同步纯文本到表单字段
    syncMultilingualFormFromView(tabName) {
      this.$nextTick(() => {
        const nameRef = this.$refs['msgName_' + tabName];
        const contentRef = this.$refs['msgContent_' + tabName];
        if (nameRef && nameRef[0]) {
          this.messageTemplateForm['title_' + tabName] = nameRef[0].innerText;
        }
        if (contentRef && contentRef[0]) {
          this.messageTemplateForm['content_' + tabName] = contentRef[0].innerText;
        }
      });
    },
    // 将【占位符】文本高亮为蓝色 HTML
    handerText(val) {
      if (val) {
        let exp = '';
        let node = '';
        const reg = /【(.+?)】/g;
        const keywordList = val.match(reg);
        if (keywordList && keywordList.length > 0) {
          keywordList.forEach((item) => {
            exp = new RegExp(item, 'g');
            node = `<span class="highlight_color">${item}</span>`;
            val = val.replace(exp, node);
          });
        }
        return val;
      }
    },
    // 进入多语言标题/内容编辑
    toggleMultilingualEdit(field) {
      const editKey = field === 'title' ? 'editTitleTalg' : 'editContentTalg';
      const inputPrefix = field === 'title' ? 'inputTitle_' : 'inputContent_';
      this[editKey] = true;
      const tabName = this.$refs['languagesTab'].tabName;
      this.$nextTick(() => {
        this.$refs[inputPrefix + tabName][0].focus({
          cursor: 'end'
        });
      });
    },
    // 多语言标题/内容失焦后高亮动态参数
    blurMultilingualEdit(field) {
      const tabName = this.$refs['languagesTab'].tabName;
      const text = this.messageTemplateForm[field + '_' + tabName];
      if (text) {
        this.messageContent[field + '_' + tabName] = this.handerText(JSON.parse(JSON.stringify(text)));
      }
      this[field === 'title' ? 'editTitleTalg' : 'editContentTalg'] = false;
    },
    // 开始拖拽动态参数，切换预览区光标样式
    handleDragStart() {
      const tabName = this.$refs['languagesTab'].tabName;
      this.$refs['msgName_' + tabName][0].style.cursor = 'move';
      this.$refs['msgContent_' + tabName][0].style.cursor = 'move';
      document.body.style.cursor = 'move';
    },
    // 拖拽结束，根据落点追加占位符到标题或内容
    handleDragEnd({newIndex}) {
      const obj = this.dynamicParamList[newIndex];
      const tagName = `【${obj.placeholder}】`;
      const tabName = this.$refs['languagesTab'].tabName;
      const dragEndX = window.event.clientX;
      const dragEndY = window.event.clientY;
      const targetContent = this.$refs['msgContent_' + tabName][0];
      const msgContent = targetContent.getBoundingClientRect();
      const targetName = this.$refs['msgName_' + tabName][0];
      const msgName = targetName.getBoundingClientRect();

      if (dragEndX >= msgName.left && dragEndX <= msgName.right &&
        dragEndY >= msgName.top && dragEndY <= msgName.bottom) {
        const name = targetName.innerText + tagName;
        this.messageTemplateForm['title_' + tabName] = name;
        this.messageContent['title_' + tabName] = this.handerText(name);
      }
      if (dragEndX >= msgContent.left && dragEndX <= msgContent.right &&
        dragEndY >= msgContent.top && dragEndY <= msgContent.bottom) {
        const content = targetContent.innerText + tagName;
        this.messageTemplateForm['content_' + tabName] = content;
        this.messageContent['content_' + tabName] = this.handerText(content);
      }
      document.body.style.cursor = 'auto';
      targetName.style.cursor = 'auto';
      targetContent.style.cursor = 'auto';
    }
  },
  watch: {
    // 消息类型变更时同步渠道、触发条件、默认模板
    'messageTemplateForm.informationType'(value, oldValue) {
      if (value == null) {
        return;
      }
      const item = this.informationTypeList.find((typeItem) => typeItem.value === value);
      if (item) {
        this.applyInformationType(item, value, oldValue);
      }
    },
    // 切回及时提醒时清空固定时间配置
    'messageTemplateForm.remindMode': {
      handler(value) {
        if (value === 1) {
          this.resetRemindFields();
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .messageTemplateStyle {
  .ivu-modal-body {
    max-height: 650px;
    overflow-y: auto;
  }

  .help_icon {
    font-size: 17px;
    color: #2D8CF0;
  }

  .channel-text {
    position: relative;
    top: -1px;
  }

  .content-tip {
    color: #B7B7B7;
    line-height: initial;
    margin: 5px 0 3px 0;
  }

  .content-tip-last {
    margin-bottom: 0;
  }

  .reminder_box {
    .ivu-tooltip-inner {
      max-width: 350px !important;
      word-wrap: break-word;
      word-break: break-all;
    }
  }

  .message_content_style {
    display: inline-block;
    width: 100%;
    min-height: 95px;
    line-height: 1.5;
    padding: 4px 7px;
    font-size: 13px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    color: #515a6e;
    background-color: #fff;
    background-image: none;
    position: relative;
    cursor: text;
    transition: border .2s ease-in-out, background .2s ease-in-out, box-shadow .2s ease-in-out;

    &:focus {
      border-color: #57a3f3;
      outline: 0;
      box-shadow: 0 0 0 2px rgba(45, 140, 240, .2);
    }
  }

  .number_style {
    display: flex;
    align-items: center;
    color: #808695;
    font-size: 12px;
    position: absolute;
    left: 347px;
    bottom: 41px;
  }

  .highlight_color {
    color: #2D8CF0;
    font-weight: bold;
  }

  .ivu-radio-wrapper {
    font-size: 13px;
    top: -3px;
  }

  .select_timer {
    .ivu-select-arrow {
      transform: translateY(-50%) rotate(0deg) !important;
    }

    .ivu-icon-ios-arrow-down:before {
      content: "\F2DA" !important;
    }
  }

  .dynamicParam_box {
    margin: 60px 0 0 20px;
    border: 1px solid #E9E9E9;
    font-size: 12px;
    text-align: center;

    .title {
      color: #333;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
    }

    .dynamicParam_box_item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border-top: 1px solid #E9E9E9;

      p {
        width: 100%;
        user-select: none;
        box-sizing: border-box;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
      }
    }

    .dragClass {
      border-top: none !important;
      cursor: move !important;
    }
  }
}
</style>
